// NOTE: 未來如果 BE 改變分詞邏輯，這邊需要同步修改
// 移除掉搜尋的 operator
const filterOperator = (source: string[]): string[] =>
  source
    .filter((item) => {
      // 去掉 AND 和 OR
      if (
        item.toLocaleUpperCase() === 'AND' ||
        item.toLocaleUpperCase() === 'OR'
      ) {
        return false
      }

      // 去掉 - 開頭的字串
      if (item.startsWith('-')) {
        return false
      }

      return true
    })
    .map((item) => item.replace(/[{}]/g, '')) // 移除 { 和 }

export default filterOperator
